"use client";

import * as React from "react";
import Note3 from "components/Note/Note3";

/** Transitional bridge — Slate/mentions/image upload until native v2 editor. */
export type MentionsRichTextEditorV2Props = React.ComponentProps<typeof Note3>;

export function MentionsRichTextEditorV2(props: MentionsRichTextEditorV2Props) {
  return <Note3 {...props} />;
}
